import './home.scss';
import React, { useRef } from 'react';
import { Trans } from 'react-i18next';
import Instraction360 from './instarction-360';
import SocialStickySidebar from './social-sticky-sidebar';
import { useState } from 'react';
import CircularCarousel from './carousel/carousel';
import { pages } from '../../general.models';
import { useOutletContext } from 'react-router';
import { useGSAP } from '@gsap/react';
import Preloader from '../intro/intro';
import gsap from 'gsap';
import { AnimatePresence, motion } from "framer-motion"
import useDeviceDetection from '../../hooks/useDeviceDetection';




function Home() {
  const carouselItems = pages.slice(1, 9);
  const { reloadState, relativeVh } = useOutletContext();
  const [isReload, setIsReload] = reloadState;
  const [tl, setTl] = useState(null);
  const carouselRef = useRef();
  const deviceType = useDeviceDetection();
  

  const handleTizzer = () => {
    carouselRef?.current?.tizzer(); // Trigger the carousel to go to the next item
  };

  useGSAP((context) => {
    if (!isReload )
      return;

    gsap.set('h1.text-slogon', { opacity: 0 })
    gsap.set('h1.text-slogon span', { opacity: 0 })
    gsap.set('.carousel', { opacity: 0, xPercent: '-=5' })
    gsap.set('.carousel-arrow', { opacity: 0 })

    if ( !tl) {
      context.kill();
      return;
    }

    gsap.timeline()
      .to('h1.text-slogon', { opacity: 1, duration: 1 }, '+=1')
      .to('h1.text-slogon span', { opacity: 1, duration: 1 }, "-=0.5")
      .to('.carousel, .carousel-arrow', { opacity: 1, duration: 0.5, xPercent: 0 })
      .add(() => handleTizzer(), "-=0.3")
      .to(".instraction360", { display: 'flex' }, '+=1.2')
      .to(".instraction360", { opacity: 1, duration: 1.8 }, '+=1.21');

    return () => {
      context.kill();
    }

  }, [{ dependencies: [tl] }]);


  return (
    <>
      {isReload && <>
        <Preloader setTl={setTl} />
        <Instraction360 setIsDisplay={setIsReload} />
      </>
      }

      {!deviceType?.isMobile && <SocialStickySidebar />}
      <div className="home-page">
        {/* <div> */}
          <CircularCarousel ref={carouselRef} carouselItems={carouselItems} vh={relativeVh} />
        {/* </div> */}
        <h1 className="text-slogon"><Trans i18nKey="home.slogen">Intersting. <span>Very intersting!</span></Trans></h1>
      </div>

      <AnimatePresence mode="wait" initial={false}>
        {!isReload &&
          <motion.div id='customers-logos' key="customers-logos"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          ></motion.div>
        }
      </AnimatePresence>

    </>

  );
};

export default Home;